import React, {Component} from "react";
import {connect} from "react-redux";

import * as windowService from "../../services/windowService";

const JsBarcode = require("jsbarcode");

class BarcodeImage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selector: "#" + props.id,
            barcode: ""
        };
    }

    componentDidMount() {
        if (this.props.barcode !== null && window.jQuery(this.state.selector).length > 0) {
            try {
                JsBarcode(this.state.selector, this.props.barcode.code, {format: this.props.barcode.format});
            } catch (e) {
                windowService.logInfo(e);
            }
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.barcode === null || nextProps.barcode.code === prevState.barcode) {
            return null;
        }

        if (window.jQuery(prevState.selector).length === 0) {
            return null;
        }

        try {
            JsBarcode(prevState.selector, nextProps.barcode.code, {format: nextProps.barcode.format});
        } catch (e) {
            windowService.logInfo(e);
        }

        return {
            barcode: nextProps.barcode.code
        };
    }

    render() {
        return (
            <img
                id={this.props.id}
                alt={this.state.barcode}
                className={this.props.className ? "background-white " + this.props.className : "background-white"}
                style={{
                    maxHeight: this.props.height,
                    maxWidth: "100%"
                }}
                src={this.props.src}
            />
        );
    }
}

export default BarcodeImage = connect((store) => {
    return {
        barcode: store.barcode.barcodeData
    };
})(BarcodeImage);
